import { connect } from 'react-redux';

import Logout from '~/Components/Pages/Logout/Logout';
import { fetchAll } from '~/Services/Container';
import { handleLogout } from '~/Redux/Modules/Auth';

const mapDispatchToProps = dispatch => {
  return {
    fetchAll: () => fetchAll(), //pass dispatches
    handleLogout: () => dispatch(handleLogout()),
  };
};

export default connect(null, mapDispatchToProps)(Logout);
